<p>keycloak works!</p>
<div>

    <button (click)="redirectToRegister()">redirectToRegister()</button>
    <button (click)="keycloakInit()">
        keycloakInit
    </button>
    <button (click)="login()">login()</button>
    <button (click)="getToken()">getToken()</button>
    <button (click)="getUsername()">getUsername()</button>
    <button (click)="logout()">logout()</button>
    <!-- <iframe sandbox="allow-scripts" src="https://auth.suryojasvi.com/auth"></iframe> -->

</div>